import React, {useEffect} from "react"
import SelectRaumcontrollerComponent from "./SelectRaumcontrollerComponent";
import {useTranslation} from "react-i18next";

export default function StepThree1Component({project, updateProject, uiState, setUiState, trackingObj, jumpTo, isIFrame}){
    const {t, i18n} = useTranslation();
    const language = i18n.resolvedLanguage;
    useEffect(() => {
        if (!isIFrame) { setTimeout(() => {document.body.style.overflow = 'unset'; }, 200); }
    }, [isIFrame]);
    return <div>
        {/*<h2>Schalterdesign auswählen</h2>*/}
        <div className="fs-container ptb-25 bg-white" style={{marginBottom: '-25px'}}>
            <SelectRaumcontrollerComponent
                project={project}
                updateProject={updateProject}
                uiState={uiState}
                updateUiState={setUiState}
                trackingObj={trackingObj}
                language={language}
                jumpTo={jumpTo}
            />
        </div>
    </div>
}
